import React, { Component } from "react";
import classNames from "classnames";
import "./index.scss";
import { cplEnquiry, reloadSummary } from "../../../../service";
import Mock from "./mock";
import { Feedback } from "@alife/next";

class AiContainer extends Component {
  constructor(props) {
    super(props);

    const {data} = props;
    this.state = {
      summary: data.summary,
      offers: data.offer && data.offer.list,
      tags: data.tags,
      showMore: false,
      shouldShowMore: false,
      reloadingFlag: false,
      showMoreHeight: 30,
      submitingFlag: false
    };

    this.handleTexAreaChange = this.handleTexAreaChange.bind(this);
    this.handleOfferClick = this.handleOfferClick.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMsgReload = this.handleMsgReload.bind(this);
    this.getShouldShowMore = this.getShouldShowMore.bind(this);
    this.handleTagMoreClick = this.handleTagMoreClick.bind(this);
  }

  componentDidMount() {
    //console.log(this.state, this.props)
    let { offers, tags } = this.state;
    if(offers && offers.length > 0) {
      offers.forEach((item, i) => {
        item.select = true;
      });
    }
    
    if(tags && tags.length > 0) {
      tags.forEach((item, i) => {
        item.select = true;
      });
    }

    if(offers && offers.length > 0) {
      offers = offers.slice(0, 4);
    }

    this.handleMsgReload();

    this.getShouldShowMore();

    this.setState({
      offers,
      tags
    });

    //曝光
    window &&
      window.goldlog.record(
        "/ifission.ifission.pcSemAiExp",
        "EXP",
        `offercount=${offers.length}`
      );
  }

  getShouldShowMore() {
    const tagsElement = document.getElementsByClassName('ai-tags')[0];
    const clientHeight = tagsElement.clientHeight;
    const scrollHeight = tagsElement.scrollHeight;

    if(scrollHeight > clientHeight) {
      this.setState({
        shouldShowMore: true
      })
    }
  }

  handleTexAreaChange(e) {
    this.setState({
      summary: e.target.value
    });
  }

  handleOfferClick(index) {
    let { offers } = this.state;
    offers.forEach((item, i) => {
      if (i === index) {
        item.select = !item.select;
      } 
    });
    this.setState({
      offers
    });
  }

  async handleMsgReload() {
    let { tags, reloadingFlag } = this.state;
    if(reloadingFlag) {
      return;
    }
    this.setState({
      reloadingFlag: true
    });
        
    const _tags = tags ? tags.filter((item) => {
      return item.select == true;
    }) : null;

    if(!_tags) {
      return;
    }

    const res = await reloadSummary(_tags);
   
    this.setState({
      summary: res.summary,
      reloadingFlag: false
    });
    
  }

  handleTagClick(index) {
    let { tags } = this.state;
    tags.forEach((item, i) => {
      if (i === index) {
        item.select = !item.select;
      } 
    });
    this.setState({
      tags
    });
  }

  handleTagMoreClick() {
    let { showMore } = this.state;
    let _showMore = !showMore;

    if(_showMore) {
      const tagsElement = document.getElementsByClassName('ai-tags')[0];
      const scrollHeight = tagsElement.scrollHeight;

      //console.log(scrollHeight);
      this.setState({
        showMoreHeight: scrollHeight
      })
    }
    
    this.setState({
      showMore: _showMore
    })
  }

  async handleSubmit() {
    let { tags, offers, summary, submitingFlag } = this.state;

    if(submitingFlag) {
      return;
    }

    this.setState({
      submitingFlag: true
    });
    let _offers = offers ? offers.filter((item) => {
      return item.select == true;
    }) : null;
    const res = await cplEnquiry({
      offerId: null,
      mobilePhone: null,
      nlq: summary,
      pushChannelType: "WANG_WANG",
      items: _offers.map((item) => {
        const isAD = item.eurl && item.eurl.includes("dj.1688.com");
        return {
          eurl: item.eurl,
          itemType: isAD ? "AD" : "OFFER",
          itemId: item.offerId,
        };
      }),
      bizId: "lp_pcasst",
      keyword: pageConfig.keywords,
      tags
    });

    this.setState({
      submitingFlag: false
    });

    if (res.code === "200") {
      Feedback.toast.show({
        type: "prompt",
        content: '已发送，待商家回复'
      });
    } else {
      Feedback.toast.show({
        type: "prompt",
        content: res.msg,
      });
    }
  }

  render() {
    let { 
      summary, 
      offers, 
      tags, 
      shouldShowMore, 
      showMore, 
      reloadingFlag, 
      showMoreHeight, 
      submitingFlag
    } = this.state;

    //console.log(reloadingFlag);

    return (
      <div className="ai-container">
        <div className="ai-title-wrapper">
          <div className="ai-title">询价智能助理</div>
          {/*<div className="ai-subtitle">根据您的历史搜索和咨询，您正在寻找这样的{pageConfig.keywords}</div>*/}
        </div>
        <div className="ai-content">
          <div className="ai-recommend">
            <div className="tips">批量咨询获取底价</div>
            <div 
              style={{height: showMore ? `${showMoreHeight}px` : '30px'}}
              className={classNames({
                'ai-tags-showMore': showMore
              }, "ai-tags-wrapper")}
            >
              <div className="ai-tags" >
                {
                  tags && tags.map((item, index) => {
                    return <div className={classNames({
                      'select': item.select
                    }, "ai-tag")} 
                      key={index}
                      onClick={this.handleTagClick.bind(this, index)}
                    >
                      {item.v}
                    </div>
                  })
                }
              </div>
              {
                shouldShowMore && 
                <div className="ai-tag-more" onClick={this.handleTagMoreClick}>
                  {
                    showMore ? 
                     <img src={'https://img.alicdn.com/imgextra/i1/O1CN01lMBXuE1stu6R4Dx3o_!!6000000005825-2-tps-100-40.png'} />:
                     <img src={'https://img.alicdn.com/imgextra/i4/O1CN01BnHmKV1xlj6p7T4r8_!!6000000006484-2-tps-100-40.png'} />
                  }
                  
                </div>
              }
            </div>
            <div className="ai-items">
              {
                offers && offers.map((item, index) => {
                  const {imgUrl, impressionEurl, select} = item;
                  return <div  
                    className={classNames('ai-item', { 
                      offer_exp: impressionEurl,
                      select: select
                    } )}
                    data-jplus-exp-url={`${impressionEurl}&idx=${index}`}
                    data-tracker="offer" 
                    key={index}
                    onClick={this.handleOfferClick.bind(this, index)}
                  >
                    <img className="ai-item-img" src={imgUrl} />
                    {
                      select ?
                      <img className="ai-item-select-icon" src={'https://img.alicdn.com/imgextra/i1/O1CN010jfWNB1YzahefIzuS_!!6000000003130-2-tps-32-32.png'} />
                      :
                      <img className="ai-item-select-icon" src={'https://img.alicdn.com/imgextra/i3/O1CN01JWR1yg2780vMORPwT_!!6000000007751-2-tps-32-32.png'} />
                    }
                  </div>
                })
              }
            </div>
          </div>
          <div className="ai-textArea-wrapper">
            <div className="tips">AI生成话术</div>
            <textArea 
              className="ai-textArea" 
              placeholder="请输入关键词内容文案发送给商家"
              value={summary}
              onChange = {this.handleTexAreaChange}
            ></textArea>
            <div className={classNames({
                'reloading': reloadingFlag
              }, "ai-textArea-reload")} onClick={this.handleMsgReload}>
            </div>
          </div>
          
        </div>
        <div className={classNames({
                'ai-bottom-showMore': showMore
              }, "ai-bottom")}>
          <div className="ai-protocol">
            点击一键发送询价单，表明您已阅读并同意
            <a
              href="https://terms.alicdn.com/legal-agreement/terms/c_end_product_protocol/20231031181421701/20231031181421701.html?spm=a261y.25179003.0.0.56883aa7cMyD2U"
              target="_blank"
            >
              《用户协议》
            </a>
          </div>
          <div className={classNames({
                'ai-button-submiting': submitingFlag
              }, "ai-button")} onClick={this.handleSubmit}>
          </div>
        </div>
        
      </div>
    );
  }
}
 
export default AiContainer